import React from "react";

import { crunchClasses } from "@cayuse/shared-react.utils.helpers";
import { isNonEmptyObject } from "@cayuse/shared-react.utils.type-checks";

import styles from "./styles.css";

const extendedCellStyles = crunchClasses({ [styles.additionalInfo]: true, [styles.maxW270]: true });

function getUserDisplayName (userObject) {
	return [
		userObject?.firstName,
		userObject?.middleName,
		userObject?.lastName,
	].filter(Boolean).join(" ");
}

export function CreatedByCell ({ ownerUserObject, fallback }) {
	if (isNonEmptyObject(ownerUserObject)) {
		return (
			<div className={styles.maxW270}>
				<span><b>{getUserDisplayName(ownerUserObject)}</b></span>
				<span className={extendedCellStyles}>{ownerUserObject.contactEmail}</span>
				<span className={extendedCellStyles}>
					{ownerUserObject.affiliations?.find(it => it.primaryAppointment)?.unitName ?? ""}
				</span>
			</div>
		);
	}

	return <div className={styles.maxW270}><b>{fallback}</b></div>;
}

export function AssignedToCell ({ teamName, assigneeUserObject, teamId, fallback }) {
	const isTeamMemberAssigned = Boolean(teamId);
	const userDisplayName = getUserDisplayName(assigneeUserObject) || fallback;

	return (
		<>
			{isTeamMemberAssigned && <span className={styles.maxW270}><b>{teamName}</b></span>}
			<span className={isTeamMemberAssigned ? extendedCellStyles : styles.maxW270}>
				{isTeamMemberAssigned ? userDisplayName : <b>{userDisplayName}</b>}
			</span>
			<span className={extendedCellStyles}>{assigneeUserObject?.contactEmail}</span>
			{!isTeamMemberAssigned ? (
				<span className={extendedCellStyles}>
					{assigneeUserObject?.affiliations?.find(it => it.primaryAppointment)?.unitName}
				</span>
			) : null}
		</>
	);
}
